module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../../node_modules/happypack/loader.js?id=jsx!./CostListView.js"));
	}, "AfterSaleDetailCostListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AfterSaleDetailCostListView!./src/pages/Shop/Member/TradeManage/AfterSale/AfterSaleDetail/CostList/CostListView.js
// module id = 1038
// module chunks = 438